//#region Libraries
//#endregion
//#region Styles
import { 
    Container, 
    Content, 
    Footer } from "../styles";
import { Image } from "./styles";
//#endregion
//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
//#endregion
//#region Images
import successImg from "../img/success_img.svg";
//#endregion

const DialogAlertSuccessNotify = ({
    show, toggleShow,
    buttons, variant,
    title, subtitle, 
    description, contentComponent
}) => {
    return (
        <DialogAlert
            show={show}
            toggleShow={toggleShow}>
            <Container>
                <Content>
                    <Image src={successImg} alt="Imagen de creación de evento exitoso UTP"/>
                    <h3 className={variant}>{title}</h3>
                    {subtitle && <h4>{subtitle}</h4>}
                    {contentComponent && contentComponent}
                    {description && <p>{description}</p>}
                </Content>
                <Footer>
                    {buttons}
                </Footer>
            </Container>
        </DialogAlert>
    );
}

export default DialogAlertSuccessNotify;